import {useContext} from 'react';
// @ts-ignore
import {__RouterContext, RouteComponentProps} from 'react-router';

export function useReactRouter<T = {}>() {
  return useContext(__RouterContext) as RouteComponentProps<T>;
}
